module.exports = __webpack_public_path__ + "static/media/intro.a3036b53.mp3";